module.exports = __webpack_public_path__ + "static/media/previous.62bcceed.svg";